import { render, staticRenderFns } from "./AppointmentAudit.vue?vue&type=template&id=4cdfcab6&scoped=true"
import script from "./AppointmentAudit.vue?vue&type=script&lang=js"
export * from "./AppointmentAudit.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAudit.vue?vue&type=style&index=0&id=4cdfcab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfcab6",
  null
  
)

export default component.exports